import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import analyticsService from './utils/analytics';

// const root = ReactDOM.createRoot(document.getElementById('root'));

const startApp = async () => {
  let digitalData = analyticsService.getDigitalData();
  digitalData['site_country'] = 'US';
  digitalData['site_language'] = 'English';
  analyticsService.setDigitalData(digitalData);

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}

startApp();
